export default __webpack_public_path__ + "static/media/node-1.fafa64b9.jpg";